const SEARCH_ID_LENGTH = 20;

export { SEARCH_ID_LENGTH };
